import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/app/settings/page.tsx");
